import React from "react";
import {
  BlocksIcon,
  ChildIcon,
  DuplicateIcon,
  LinkTicketIcon,
  ParentIcon,
} from "app/components/Icons";
import BlockIcon from "app/components/Icons/BlockIcon";
import { Option } from "app/types";
import { TicketRelationCounts, TicketRelationTypeQuery } from "./types";

export type RelationTypeOption = Option & {
  countKey: keyof TicketRelationCounts;
};

export const relationTypeOptions: RelationTypeOption[] = [
  {
    label: "Blocked by",
    value: TicketRelationTypeQuery.BLOCKED_BY,
    countKey: "blockedBy",
    icon: <BlockIcon size={20} />,
  },
  {
    label: "Blocks",
    value: TicketRelationTypeQuery.BLOCKS,
    countKey: "blocks",
    icon: <BlocksIcon size={20} />,
  },
  {
    label: "Duplicated",
    value: TicketRelationTypeQuery.DUPLICATED,
    countKey: "duplicated",
    icon: <DuplicateIcon size={20} />,
  },
  {
    label: "Parent",
    value: TicketRelationTypeQuery.PARENT,
    countKey: "parent",
    icon: <ParentIcon size={20} />,
  },
  {
    label: "Child",
    value: TicketRelationTypeQuery.CHILD,
    countKey: "child",
    icon: <ChildIcon size={20} />,
  },
  {
    label: "Linked ticket",
    value: TicketRelationTypeQuery.LINKED_TICKET,
    countKey: "linkedTicket",
    icon: <LinkTicketIcon size={20} color="#2CBB93" />,
  },
];
